import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ReservationRow } from '@smile/shared';
import { ApiError, api } from '../api/client';

/**
 * "Telefonicky ověřen" — the legacy dashboard's q_called: the dispatcher
 * rang the customer and the arrival is confirmed. One press, no form; the
 * row then carries the ☎ mark the legacy's legend calls "Klient telefonicky
 * ověřen". Offered while the booking is still expected (new/pending/paid,
 * no car yet) and not already marked.
 */
export function CalledButton({ r, compact }: { r: ReservationRow; compact?: boolean }) {
  const qc = useQueryClient();
  const m = useMutation({
    mutationFn: () => api.markCalled(r.id),
    onSuccess: async () => qc.invalidateQueries(),
  });
  const eligible = ['new', 'pending', 'paid'].includes(r.status) && !r.arrivalReal;

  if (r.called) return <span className="arrived-mark" title="Klient telefonicky ověřen">☎ ověřeno</span>;
  if (!eligible) return null;

  const err = m.error;
  const message =
    err instanceof ApiError
      ? err.serverMessage ?? (err.code === 'forbidden' ? 'Na tuhle akci nemáte oprávnění.' : err.message)
      : err instanceof Error
        ? err.message
        : null;

  return (
    <span className="statusbtns" onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className={compact ? 'btn sm' : 'btn'}
        onClick={() => m.mutate()}
        disabled={m.isPending}
        title="Telefonické potvrzení příjezdu klienta."
      >
        {m.isPending ? 'Ukládám…' : '☎ Telefonicky ověřen'}
      </button>
      {message && <span className="arrive-error" role="alert">{message}</span>}
    </span>
  );
}
